module.exports = __webpack_public_path__ + "img/06.8ee2721e.jpg";